<template>
    <div class="w-full max-w-4xl flex flex-col items-start justify-start ">
        <div class="text-black text-lg font-semibold mt-10 mb-5">
            {{ workbooks.length > 0 ? "Workbooks" : "Materialien" }}
        </div>
        <document
            :media="doc"
            v-for="(doc, index) in workbooks"
            :key="index"
            class="border-grey-blue"
            :inCourse="true"
            @open-media="openMedia(doc)"
        />
        <custom-button
            class="w-80 h-11"
            :class="workbooks.length > 0 ? 'mt-5' : 'mt-3'"
            :text="'Workbook und Aufgaben hochladen'"
            :bgColor="'bg-primary'"
            :textColor="'text-white'"
            :id="'upload-button'"
            @click="$refs.fileInput.click()"
        >
            <template #icon>
                <upload-icon
                    :fillClass="'fill-white'"
                    class="mr-4 w-5"/></template
        ></custom-button>
        <input
            type="file"
            ref="fileInput"
            hidden
            @change="UPLOAD_COURSE_WORKBOOK"
        />
        <div class="flex flex-row justify-start items-center w-full mb-8 mt-3">
            <success-icon class="mr-2" v-if="workbooks.length > 0" />
            <info-icon class="mr-2" v-else />
            <div
                class="text-sm font-semibold text-black-light select-none whitespace-pre-wrap   "
                style="calc(100% - 30px)"
            >
                {{
                    workbooks.length > 0
                        ? "Datei erfolgreich eingereicht."
                        : "Noch keine Datei eingereicht."
                }}
            </div>
        </div>
        <div
            class="text-black text-lg font-semibold mt-5 mb-5"
            v-if="workbooks.length > 0"
        >
            Materialien
        </div>
        <document
            :media="doc"
            v-for="(doc, index) in courseMaterials"
            :key="index"
            class="border-grey-blue"
            :inCourse="true"
            @open-media="openMedia(doc)"
        />
    </div>
</template>

<script>
import { computed, defineComponent, reactive } from "@vue/runtime-core";
import { useStore } from "vuex";
import { getData } from "../../common/dataHelper";
import CustomButton from "../../components/input/CustomButton.vue";
import { COURSE_TYPES, HELPER_TYPES, STORE_TYPES } from "../../store/types";
import Document from "./Document.vue";

export default defineComponent({
    emits: ["openMedia"],
    components: { CustomButton, Document },
    setup(_1, ctx) {
        const store = useStore();
        /**
         *  State
         */
        const state = reactive({});
        /**
         *  Functions
         */
        async function UPLOAD_COURSE_WORKBOOK(event) {
            const files = event.target.files;
            if (!files) {
                return;
            }
            const file = files[0];
            store.commit(
                `${STORE_TYPES.HELPERS}/${HELPER_TYPES.SET_LOADING_ID}`,
                "upload-button"
            );
            const response = await store.dispatch(
                `${STORE_TYPES.COURSES}/${COURSE_TYPES.UPLOAD_COURSE_WORKBOOK}`,
                {
                    file,
                }
            );
            if (getData(response, "status") != 201) {
                store.commit(
                    `${STORE_TYPES.HELPERS}/${HELPER_TYPES.SET_TOAST_MESSAGE}`,
                    "Fehler beim Upload."
                );
            }
            event.target.files = null;

            store.commit(
                `${STORE_TYPES.HELPERS}/${HELPER_TYPES.REMOVE_LOADING_ID}`,
                "upload-button"
            );
        }
        /**
         *  Computed
         */
        const GET_COURSE = computed(
            () =>
                store.getters[
                    `${STORE_TYPES.COURSES}/${COURSE_TYPES.GET_COURSE}`
                ]
        );
        const courseMaterials = computed(() => {
            const courseMaterials = getData(GET_COURSE, "value.materials");
            if (courseMaterials) {
                return courseMaterials.filter(
                    (mat) => mat.collection != "workbook"
                );
            }
            return [];
        });
        const workbooks = computed(() => {
            const courseMaterials = getData(GET_COURSE, "value.materials");
            if (courseMaterials) {
                return courseMaterials.filter(
                    (mat) => mat.collection == "workbook"
                );
            }
            return [];
        });

        /**
         *  Created
         */

        function openMedia(media) {
            ctx.emit("openMedia", media);
        }

        return {
            state,
            UPLOAD_COURSE_WORKBOOK,
            courseMaterials,
            workbooks,
            openMedia,
        };
    },
});
</script>
